module.exports = __webpack_public_path__ + "static/img/8bg_12.cb1139e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_12.png
// module id = 759
// module chunks = 1